var map = {
  "./cs.json": [
    "Peh",
    [
      "l3"
    ]
  ],
  "./en.json": [
    "i55",
    [
      "wt"
    ]
  ],
  "./pl.json": [
    "ti",
    [
      "ju"
    ]
  ],
  "./ru.json": [
    "Npf",
    [
      "rw"
    ]
  ],
  "./tr.json": [
    "SAy",
    [
      "wt8"
    ]
  ],
  "./ja.json": [
    "K2",
    [
      "ka"
    ]
  ],
  "./zh.json": [
    "MyB",
    [
      "mu"
    ]
  ],
  "./pt-br.json": [
    "nY",
    [
      "p7"
    ]
  ],
  "./de.json": [
    "oH",
    [
      "ay"
    ]
  ],
  "./es.json": [
    "Ne",
    [
      "3pm"
    ]
  ],
  "./fr.json": [
    "Pdp",
    [
      "xv"
    ]
  ],
  "./it.json": [
    "Y7",
    [
      "miz"
    ]
  ],
  "./ko.json": [
    "vwN",
    [
      "di"
    ]
  ],
  "./pt.json": [
    "rYN",
    [
      "l3a"
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 3 | 16)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = "jJ";
module.exports = __rspack_async_context;
